import { Component, inject } from '@angular/core';
import { ForestryManagementService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ForestryManagementCreateDto,
  ForestryManagementDto,
  ForestryManagementExcelDownloadDto,
  ForestryManagementUpdateDto,
} from '../proxy/planning/dtos/forestry-management';
import { FORESTRYMANAGEMENT_CONFIG, FORESTRYMANAGEMENT_FIELDS } from './forestry-management.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-forestry-management',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ForestryManagementService, ConfirmationService],
  templateUrl: './forestry-management.html',
  styleUrl: './forestry-management.scss',
})
export class ForestryManagement extends BaseCrudComponent<
  ForestryManagementDto,
  ForestryManagementCreateDto,
  ForestryManagementUpdateDto,
  ForestryManagementExcelDownloadDto
> {
  service = inject(ForestryManagementService);
  config = FORESTRYMANAGEMENT_CONFIG;
  fields = FORESTRYMANAGEMENT_FIELDS;

  protected prepareUpdateDto(data: any, selected: ForestryManagementDto): ForestryManagementUpdateDto {
    return {
      certificationCodeId: data.certificationCodeId,
      expirationDate: data.expirationDate,
      notes: data.notes,
      certificationTypeId: data.certificationTypeId,
      isNotCertificationValue: data.isNotCertificationValue,
      vendorId: data.vendorId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ForestryManagement';
  }
}
